"use client"
import { useState, useRef } from "react";
import { deleteSubTask, deleteTask } from "../api";


export default function DeleteSubTaskModal({subtask,setSelectedSubTask,setTasks1,setTasks2,setFilteredTasks,setSubTasks}:any) {
  const [isDeleting, setIsDeleting] = useState<boolean>(false);  // To track the deleting state
  const closeButtonRef = useRef<HTMLButtonElement | null>(null); // Ref for the close button

    // console.log(list)

  const handleDelete = async (): Promise<void> => {
    setIsDeleting(true);

    try {
      const response = await deleteSubTask(subtask.subtaskId);
                                    
    setSubTasks((prevTasks:any) => prevTasks.filter((t:any) => t.subtaskId !== subtask.subtaskId));

            if (response) {
        // Use the ref to trigger the modal close
            setSelectedSubTask(null)
            setTasks2((prevTasks2: any) => ({
                ...prevTasks2, // Preserve the other properties (total_logs, page, page_size)
                logs: prevTasks2.logs.filter((t: any) => t.subtaskId !== subtask.subtaskId), // Update the logs array
              }));
        if (closeButtonRef.current) {
          closeButtonRef.current.click(); // Programmatically click the close button to dismiss the modal
        }
      } else {
        console.error("Failed to delete the list");
      }
    } catch (error) {
      console.error("An error occurred:", error);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <div
      className="edit-modal modal fade add-wallet-modal"
      id="deleteSubTaskModal"
      tabIndex={-1}
      aria-labelledby="exampleModal4Label"
    >
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Delete Task</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={closeButtonRef} // Attach ref to the close button
            ></button>
          </div>
          <div className="modal-body">
            <h5 className="fw-normal mb-0">
            Are you sure you want to delete the subtask? <br />
            <strong>Note:</strong> This action is irreversible
            </h5>
            
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline-primary px-3 py-2"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-danger ms-3 px-3 py-2"
              onClick={handleDelete}
              disabled={isDeleting}  // Disable the button while deleting
            >
              {isDeleting ? (
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              ) : (
                "Confirm"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
